import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import AV from "../av-package";
import {
  fetchSignInMethodsForEmail,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
} from "firebase/auth";
import { auth } from "../util/firebase";
import { Spinner } from "react-bootstrap";
import Common from "../common/common";
import { collection, getFirestore, doc, getDoc } from "firebase/firestore";
import { app } from "../util/firebase";
import ModalCribSuccess from "../modals/ModalCribSuccess";
import ModalCribFailure from "../modals/ModalCribFailure";

const db = getFirestore(app);

function Wallet({ setOpen, open, setUser }) {
  const [installedExt, setInstalledExt] = useState([]);
  const [extensionsNames, setExtensionsNames] = useState([]);
  const [extensionsIds, setExtensionsIds] = useState([]);
  const [loader, setLoader] = useState(true);

  const [state, setState] = useState({
    isShowSuccess: false,
    isShowFaliure: false,
  });
  let walletAddress = "";
  let encryptedWalletAddress = "";

  useEffect(() => {
    async function getData() {
      await checkIfCardanoPluginsInstalled();
      await getExtensionsData();
      setLoader(false);
    }
    getData();
  }, []);

  const checkIfCardanoPluginsInstalled = async () => {
    let installedExt = [];
    AV.getAvailableExtensions().then((extension) => {
      installedExt.push(extension);
    });
    setInstalledExt(installedExt);
  };

  const getExtensionsData = () => {
    setExtensionsNames(AV.getExtensionsNames());
    setExtensionsIds(AV.getExtensionsIds());
  };

  const checkWallet = async (wallet) => {
    setLoader(true);

    try {
      await AV.connect(wallet)
        .then(async (connected) => {
          walletAddress = await AV.getConnectedWalletAddress();
          encryptedWalletAddress = window.btoa(walletAddress); // returns encrypted  walletAddress

          if (connected) {
            const whitelist_member = await checkIfWhitelistMember(
              walletAddress
            );

            if (whitelist_member) {
              fetchSignInMethodsForEmail(auth, walletAddress + "@gmail.com")
                .then((providers) => {
                  if (providers.length === 0) {
                    createAccount();
                  } else {
                    signin();
                  }

                  setTimeout(function () {
                    Common.createToWallets(walletAddress, wallet);
                    localStorage.setItem("wallet", wallet);
                    setUser(walletAddress);
                    setLoader(false);
                    setOpen(false);

                    setState((state) => ({
                      ...state,
                      isShowSuccess: true,
                    }));
                  }, 3000);
                })
                .catch((error) => {
                  setLoader(false);
                  toast.error(error.message, { theme: "colored" });
                });
            } else {
              setLoader(false);
              setOpen(false);
              setState((state) => ({
                ...state,
                isShowFaliure: true,
              }));
            }
          } else {
            setLoader(false);
            toast.error("User declined to connect the wallet", {
              theme: "colored",
            });
          }
        })
        .catch((error) => {
          setLoader(false);
          toast.error(error.message, { theme: "colored" });
        });
    } catch (error) {
      setLoader(false);
      toast.error("Error while connecting wallet", { theme: "colored" });
    }
  };

  async function checkIfWhitelistMember(email) {
    const docRef = doc(
      collection(db, process.env.REACT_APP_COLLECTION_NAME),
      email.toString()
    );
    const snapshot = await getDoc(docRef);
    if (snapshot?.exists()) return true;
    else return false;
  }

  // Firebase methods
  // Sign up
  const createAccount = () => {
    // create Account
    createUserWithEmailAndPassword(
      auth,
      walletAddress + "@gmail.com",
      encryptedWalletAddress
    )
      .then((userCredential) => {
        // Signed in
        const user = userCredential.user;
        localStorage.setItem("access_token", user.accessToken);
        localStorage.setItem("refresh_token", user.refreshToken);
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
      });
  };

  // Sign in
  const signin = () => {
    signInWithEmailAndPassword(
      auth,
      walletAddress + "@gmail.com",
      encryptedWalletAddress
    )
      .then((userCredential) => {
        // Signed in
        const user = userCredential.user;
        localStorage.setItem("access_token", user.accessToken);
        localStorage.setItem("refresh_token", user.refreshToken);
      })
      .catch((error) => {
        const errorCode = error.code;
      });
  };

  return (
    <div
      className={`modal customePopup ${open ? "show" : "fade"}`}
      id="multiWallet"
      tabIndex="-1"
      aria-labelledby="multiWalletLabel"
      aria-hidden="true"
      style={{ display: open ? "block" : "none" }}
    >
      <div className="modal-dialog modal-dialog-centered popup-md">
        <div className="modal-content">
          {loader && (
            <div className="generalLoader ">
              <Spinner size="lg" variant="border" />
            </div>
          )}
          <div className="modal-header">
            <span
              className="close bg-dark"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={() => {
                setOpen(false);
              }}
            ></span>
          </div>
          <div className="modal-body text-center">
            <h3 className="title text-uppercase px-2r">Choose your wallet</h3>
            <p>Please select your wallet from the following list!</p>

            <ul className="wallet-list text-start">
              {extensionsIds &&
                extensionsIds.map((id, index) => (
                  <li
                    key={index}
                    className={`list-item ${
                      installedExt !== undefined &&
                      installedExt[0]?.includes(id)
                        ? "active"
                        : "nonactive"
                    }`}
                    onClick={checkWallet.bind(this, id)}
                  >
                    <label>{extensionsNames[index]}</label>
                    <span>
                      {installedExt && installedExt[0]?.includes(id) ? (
                        <i className="success">Installed</i>
                      ) : (
                        <i className="error">Not Installed</i>
                      )}
                    </span>
                  </li>
                ))}
            </ul>
          </div>
        </div>
      </div>
      <ModalCribSuccess
        isShowSuccess={state.isShowSuccess}
        handleClose={() => {
          setState((state) => ({
            ...state,
            isShowSuccess: false,
          }));
        }}
      />
      <ModalCribFailure
        isShowSuccess={state.isShowFaliure}
        handleClose={() => {
          setState((state) => ({
            ...state,
            isShowFaliure: false,
          }));
        }}
      />
    </div>
  );
}

export default Wallet;
